import { RouteConfig } from "vue-router";

const notasCredito: RouteConfig = {
  path: "/notasCredito",
  name: "notasCredito",
  component: () => import(/* webpackChunkName: "notas-credito" */ "@/views/NotasCredito.vue"),
};

export default notasCredito;
